<template>

    <a-modal title=""
             :width="800"
             :visible="visible"
             @cancel="$emit('cancel')"
             :maskClosable="false"
             :footer="null"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <div style="height: 20px;"></div>
        <a-card>
            <table class="fx-form-view">
                <tr>
                    <th>回复人</th>
                    <td>
                        {{answer.answerName}}
                    </td>
                    <th>回复时间</th>
                    <td>
                        {{answer.answerTime}}
                    </td>
                </tr>
                <tr style="height: 300px;">
<!--                    <th>回复状态</th>-->
<!--                    <td>-->
<!--                        {{answer.status === '1' ? '已回复' : '未回复'}}-->
<!--                    </td>-->
                    <th>回复内容</th>
                    <td colspan="3">
                        {{answer.answerContent}}
                    </td>
                </tr>

            </table>
        </a-card>

    </a-modal>

</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'

    export default {
        components: {
        },
        created() {
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                packs:'',
                modalLoading: false,
                answer: ''
            }
        },
        methods: {
            onSubmit() {
            },
            initData(id) {
                // console.log(id);
                let that = this
                this.$http.get('/api/v1/reply/get.json?id='+id).then(function (res) {
                    console.log(res)
                    that.answer = res.result
                })
            }
        }
    };
</script>
<style lang="less" scoped>
    .text-header{
        text-align: center;
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 24px;
    }
    .text-header span{
        flex: 1;
    }
    /deep/ .p-0 .ant-card-body{
        padding: 0;
    }
    /deep/ .ant-tabs-nav .ant-tabs-tab {
        font-size: 20px;
        font-weight: bold;
    }
    /deep/ .ant-tabs-bar {
        margin-bottom: 0;
        border-bottom: 3px solid #e6e6e6;
    }
</style>
